<template>
  <div><GetOXml /> <InsertOXml /><br /><InsertWordTemplateBtn /></div>
</template>
<script>
import GetOXml from "@/components/WordTemplates/GetOXml.vue";
import InsertOXml from "@/components/WordTemplates/InsertOXml.vue";
import InsertWordTemplateBtn from "@/components/WordTemplates/InsertWordTemplateBtn.vue";
export default {
  components: {
    GetOXml,
    InsertOXml,
    InsertWordTemplateBtn
  }
};
</script>
